var chunkToChildrenMap = {
	"3944": [
		6611,
		384
	],
	"7984": [
		6611,
		1426
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };